<template>
  <div class="promotion-page">

		<el-breadcrumb style="margin-top: 15px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Campaign/' + $route.params.Id }" class="first-breadcrumb">{{ $t("promomgmt.t1") }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t("promomgmt.t6") }}</el-breadcrumb-item>
		</el-breadcrumb>

    <el-button
      class="import-page-upload-text campaign-management-btn import-page-upload-text1" 
      type="text" size="mini" @click="getSkuTemplate()">{{ $t("promomgmt.t12") }}</el-button>
    <el-button
      :disabled="campinfo.status == 3"
      class="import-page-upload-btn campaign-management-btn" 
      type="danger" size="mini" @click="onClickUpload()">{{ $t("promomgmt.t13") }}</el-button>
    <input ref="exceluploadinput" class="upload-input-file" type="file" hidden accept=".xlsx, .xls" @change="handleClick" />
    
    <div class="promotion-detail">
      <el-descriptions class="margin-top" :column="5" size="small" border labelClassName="campdetail-desc">
        <el-descriptions-item label="CampID" contentClassName="campdetail-desc-content-campid">
          {{ campinfo.campId }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('promomgmt.t8')" contentClassNamee="campdetail-desc-content-name">
          <span class="el-descriptions-span">{{ campinfo.name }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('dsfx.t20')" labelClassName="campdetail-desc-channel" contentClassName="campdetail-desc-content-channel">
          <i v-for="(icon, index) in channels" :key="index" class="channelicon" :class="setChannel(icon).src"></i>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('promomgmt.t9')" contentClassName="campdetail-desc-content-time">
          <span class="el-descriptions-span" v-if="false == showedittime">
            {{ $moment(campinfo.startTime).format('YYYY-MM-DD HH:mm') }} - 
            {{ $moment(campinfo.endTime).format('YYYY-MM-DD HH:mm') }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('dsfx.t27')" contentClassName="campdetail-desc-content-campid">
          {{ campinfo.status == 1 ? $t("promomgmt.t2") : campinfo.status == 2 ? $t("promomgmt.t3") : campinfo.status == 3 ? $t("promomgmt.t4") : '' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="promotion-detail-list">
      <el-table :data="exceldatatable"
        :cell-style="getTableCellStyle"
        @cell-dblclick="editSinglePrcie"
        size="mini" 
        tooltip-effect="dark" 
        style="width: 100%;">
        <el-table-column label="SKUID" prop="SKUID" width="100" fixed></el-table-column>
        <el-table-column :label="$t('jgjk.s13')" prop="SKUSeries" width="100"></el-table-column>
        <el-table-column :label="$t('report.s18')" prop="SKUName" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s14')" prop="SKUModel" width="100"></el-table-column>
        <el-table-column :label="$t('jgjk.s16')" prop="SKUSpec" width="100"></el-table-column>
        <el-table-column label="SKUCODE" prop="UserSKUCode" width="120"></el-table-column>
        <el-table-column :label="$t('jgjk.s305')" prop="price" width="100"></el-table-column>
        <el-table-column :label="$t('promomgmt.t11')" header-align="center">
          <el-table-column v-for="id in channels" :key="id" :label="id" width="80" :prop="setChannel(id).loc">
            <template slot="header">
              <span class="fl">{{ setChannel(id).loc }}</span><i class="channelicon" :class="setChannel(id).src"></i>
            </template>
            <template slot-scope="scope">
              <span v-if="dbclickedit[scope.row._index][setChannel(id).cid] == false">{{ scope.row[setChannel(id).cid] }}</span>
              <el-input 
                v-if="dbclickedit[scope.row._index][setChannel(id).cid] == true"
                v-model="scope.row[setChannel(id).cid]" 
                size="mini"
                v-inputfocus
                @blur="savePrice(scope.row._index, scope.row[setChannel(id).cid], setChannel(id).cid, scope.row)"
                @keyup.enter.native="savePrice(scope.row._index, scope.row[setChannel(id).cid], setChannel(id).cid, scope.row)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="size"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>
    
    <el-dialog
      :title="$t('promomgmt.t14', [excellength])"
      :visible.sync="confirmImport"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <div class="confirmimportbody">
        <el-button size="mini" type="danger" @click="uploadData()">上传</el-button>
      </div>
      
    </el-dialog>

  </div>
</template>

<script>
import * as XLSX from 'xlsx'
export default {
  data(){
    return{
			taskid: '',
      brandname: '',
      campid: this.$route.params.Pid,
      showedittime: false,
      showeditname: false,
      startend: ['', ''],
      channels: [],
      campinfo: {},
      lists: [],
      exceldata: [],
      exceldatatable: [],
      confirmImport: false,
      excellength: 0,
      page: 1,
      size: 25,
      pagingtotal: 0,
      dbclick: {},
      dbclickedit: []
    }
  },

  mounted(){
		/**
		 * 获取当前订阅详情
		 */
		let that = this
		let current = that.getCurrentInfo()
		that.taskid = current.taskid
    that.brandname = current.name

    that.getActivitinfo()
    that.getChannelList(function(){
      that.getPriceList()
    })

  },

  methods: {

    edittime: function(){
      this.showedittime = true
    },

    editname: function(){
      this.showeditname = true
    },

    saveTime: function(){
      this.showedittime = false
    },

    saveName: function(){
      this.showeditname = false
    },

		/**
		 * 获取渠道列表
		 */
    getActivitinfo: function(){
			let that = this
			let url =  this.API_URL + '/v3/price/activity/findActivitinfo'
			let _data = {
				campId : that.campid
			}
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _data,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          that.campinfo = rex.results[0]
          that.startend = [that.$moment(rex.results[0].startTime).format('YYYY-MM-DD HH:mm'), that.$moment(rex.results[0].endTime).format('YYYY-MM-DD HH:mm')]
        },
        error: function(response) {
          console.log('getActivitinfo', response)
        }
      })
		},

		/**
		 * 获取渠道列表
		 */
    getChannelList: function(callback){
			let that = this
			let url =  this.API_URL + '/v3/price/activity/findChannelList'
			let _data = {
				taskId : that.taskid
			}
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _data,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					let _res = rex.results[0].ChannelIDList
					_res = _res.split(',')
					that.channels = _res

          let _t = {}
          for(let k=0; k<_res.length; k++){
            _t[_res[k]] = false
          }
          that.dbclick = _t
          callback()
        },
        error: function(response) {
          console.log('getChannelList', response)
        }
      })
		},

    /**
     * 下载SKU模板
     */
    getSkuTemplate: function(){
      let that = this
      let url = that.API_URL + '/v3/price/activity/download?taskId=' + this.taskid + '&name=' + this.brandname
      let filename = 'Campaign_' + that.$moment(new Date()).format('YYYYMMDDhhmmss')
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send()
      // let url = that.API_URL + '/v3/price/activity/download?taskId=' + this.taskid + '&name=' + this.brandname
      // $.ajax({
      //   url:  url,
      //   type: "GET",
      //   headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
      //   changeOrigin: true,
      //   crossDomain: true,
      //   success: function(rex) {
      //     console.log(rex)
      //   },
      //   error: function(response) {
      //     console.log('getSkuTemplate', response)
      //   }
      // })
      // window.open(this.API_URL + '/v3/price/activity/download?taskId=' + this.taskid + '&name=' + this.brandname)
    },

    /**
     * 判断是否Excel
     */
     isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },

    /**
     * 选取Excel文件
     */
    onClickUpload: function(){
      this.$refs.exceluploadinput.click()
    },

    /**
     * 读取Excel文件
     */
    handleClick: function(e){
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      if (!this.isExcel(rawFile)) {
        this.$message.error('Only supports upload .xlsx, .xls, .csv suffix files')
        return
      }
      this.readExcel(rawFile)
    },
    
    /**
     * 上传
     */
    readExcel: function(rawFile) {
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.onload = e => {
          let data = e.target.result
          let workbook = XLSX.read(data, { type: 'array' })
          let _sheetname = workbook.SheetNames[0]
          let _worksheet = workbook.Sheets[_sheetname]
          let _results = XLSX.utils.sheet_to_json(_worksheet)
          this.exceldata = _results
          this.excellength = _results.length
          this.confirmImport = true
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },

    /**
     * 上传Excel
     */
    uploadData: function(){
      let that = this
      let _excel = that.exceldata
      let _data = []
      for(let i=0; i<_excel.length; i++){
        let _item = _excel[i]
        var skuId = JSON.parse(JSON.stringify(_item.SKUID))
        _item.skuId = skuId
        delete _item.SKUCODE
        delete _item['SKUID']
        delete _item['参数']
        delete _item['商品名称']
        delete _item['型号']
        delete _item['常规监测价']
        delete _item['系列']
        _data.push(_item)
      }
      let _query = {
        campId: that.campid * 1,
        taskId: that.taskid * 1,
        excel: _data
      }
			let url = that.API_URL + '/v3/price/activity/upload'
      $.ajax({
        url:  url,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(_query),
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          that.getPriceList()
          that.confirmImport = false
        },
        error: function(response) {
          console.log('uploadData', response)
        }
      })
    },

    /**
     * 获取价格详情列表
     */
    getPriceList: function(){
			let that = this
			let url =  this.API_URL + '/v3/price/activity/detailpaging'
			let _data = {
        campId: that.campid * 1,
        taskId: that.taskid * 1,
        page: that.page,
        size: that.size
			}
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _data,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          let _lists = rex.results[1]
          _lists.forEach((item, index) => {
            item._index = index
          })
          let _dbclick = []
          for(let i=0; i<_lists.length; i++){
            let _t = {}
            for(let k=0; k<that.channels.length; k++){
              _t[that.channels[k]] = false
            }
            _dbclick.push(_t)
          }
          that.dbclickedit = _dbclick
          
          that.exceldatatable = _lists
          that.pagingtotal = rex.results[0][0].Count
        },
        error: function(response) {
          console.log('getPriceList', response)
        }
      })
    },

    /**
     * 修改每页显示条数
     */
    handleSizeChange: function(val){
      this.size = val
      this.page = 1
      this.getPriceList()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getPriceList()
    },

    /**
     * 修改活动价
     */
    editSinglePrcie: function(row, column){
      let that = this
      if(that.campinfo.status != 3 && column.level == 2){
        that.dbclickedit[row._index][column.label] = true
      }
    },

    /**
     * 保存活动价
     */
    savePrice: function(_index, _val, _cid, row){
      // console.log(_val)
      // if(typeof(_val) != Number) return
      let that = this
      let _query = {
        skuId: row.SKUID,
        campId: that.campid * 1,
        activityStartTime: that.startend[0],
        activityEndTime: that.startend[1],
        activityPrice: _val,
        channelId: _cid
      }
      console.log(_query)
			let url = that.API_URL + '/v3/price/activity/setactivitPrice'
      $.ajax({
        url:  url,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(_query),
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('savePrice', rex)
          // that.getPriceList()
        },
        error: function(response) {
          console.log('savePrice', response)
        }
      })
      that.dbclickedit[_index][_cid] = false
    },

  }
}
</script>